import { SET_SELECTED_SCHEDULE_PREFERENCE } from 'actions';
import { SchedulePreference } from 'typings';

export function setSelectedSchedulePreference(
  selectedSchedulePreference: SchedulePreference,
) {
  return { selectedSchedulePreference, type: SET_SELECTED_SCHEDULE_PREFERENCE };
}
